import { graphql } from "react-relay";

export const TRANSFER_LICENSES_MUTATION = graphql`
	mutation transferLicenseButton_TransferLicensesMutation(
		$input: TransferLicensesInput!
		$connections: [ID!]!
	) {
		Admin {
			Billing {
				transferLicenses(input: $input) {
					edges {
						node {
							id @deleteEdge(connections: $connections)
						}
					}
					clientMutationId
				}
			}
		}
	}
`;
